
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/business-use-cases-scheduled-microsoft-teams-messages",
      function () {
        return require("private-next-pages/article/business-use-cases-scheduled-microsoft-teams-messages.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/business-use-cases-scheduled-microsoft-teams-messages"])
      });
    }
  